// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* Footer */
.footer {
  top: 20px;
  width: 100%;
  background-color: #152046;
  margin: auto;
  z-index: 1;
}

.footerup {
  display: flex;
  padding: 40px 0 20px 0;
  border-bottom: 1px solid white;
}

.flogo {
  width: 300px;
  margin-right: 50px;
}

.contact {
  display: flex;
  align-items: center;
  margin-right: 50px;
}

.footerup .contact .icon {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #FFB342;
  margin-right: 1rem;
}

.contact .text {
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
}

.footerdown {
  display: flex;
  padding: 20px 0 20px 0;
}

.footerdown .text {
  color: white;
  margin-left: 30px;
}

.copyright {
  color: white;
  text-align: center;
  padding: 0 150px;
}

.footerdown .icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #152046;
  text-align: center;
  padding: 0.7rem;
  margin-right: 1rem;
}

.sicon {
  color: white;
}

@media (max-width: 1220px) {
  .footerup {
    flex-wrap: wrap;
    max-width: 100%;
    width: 100%;
  }
  .flogo {
    margin-bottom: 1rem;
    max-width: 100%;
  }
  .contact {
    max-width: 100%;
    width: 100%;
    margin-bottom: 1rem;
  }
  .copyright {
    display: none;
  }
  .footerdown .icons {
    margin-top: 1rem;
    display: flex;
    width: 100%;
  }
}
@media (max-width: 1220px) {
  .footer {
    padding-bottom: 80px; /* 預留空間，大於那三顆按鈕的高度 */
  }
  .footerdown {
    flex-direction: column; /* 手機板改成上下排 */
    align-items: flex-start; /* 左對齊，如果想要置中可以改成 center */
  }
  .footerdown .text {
    margin-left: 0; /* 清掉原本左邊距，避免擠到 */
    margin-bottom: 1rem; /* 跟 icons 保持一點間距 */
  }
  .footerdown .icons {
    margin-top: 0; /* 因為已經有 text 的 margin-bottom */
    width: 100%;
    justify-content: flex-start; /* 你也可以改成 center 置中 */
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/footer.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,WAAA;AACA;EACI,SAAA;EACA,WAAA;EACA,yBAAA;EACA,YAAA;EACA,UAAA;AAEJ;;AACA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;AAEJ;;AAAA;EACI,YAAA;EACA,kBAAA;AAGJ;;AADA;EACI,aAAA;EACA,mBAAA;EACA,kBAAA;AAIJ;;AADA;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;AAIJ;;AADA;EACI,WAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,gBAAA;AAIJ;;AAFA;EACI,aAAA;EACA,sBAAA;AAKJ;;AAHA;EACI,YAAA;EACA,iBAAA;AAMJ;;AAJA;EACI,YAAA;EACA,kBAAA;EACA,gBAAA;AAOJ;;AALA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAQJ;;AANA;EACI,YAAA;AASJ;;AANA;EACI;IACI,eAAA;IACA,eAAA;IACA,WAAA;EASN;EAPE;IACI,mBAAA;IACA,eAAA;EASN;EAPE;IACI,eAAA;IACA,WAAA;IACA,mBAAA;EASN;EAPE;IACI,aAAA;EASN;EANE;IACI,gBAAA;IACA,aAAA;IACA,WAAA;EAQN;AACF;AANA;EACI;IACI,oBAAA,EAAA,oBAAA;EAQN;EALE;IACI,sBAAA,EAAA,aAAA;IACA,uBAAA,EAAA,0BAAA;EAON;EAJE;IACI,cAAA,EAAA,iBAAA;IACA,mBAAA,EAAA,mBAAA;EAMN;EAHE;IACI,aAAA,EAAA,+BAAA;IACA,WAAA;IACA,2BAAA,EAAA,qBAAA;EAKN;AACF","sourcesContent":["/* Footer */\n.footer {\n    top: 20px;\n    width: 100%;\n    background-color:  #152046;\n    margin: auto;\n    z-index: 1;\n}\n\n.footerup {\n    display: flex;\n    padding: 40px 0 20px 0;\n    border-bottom: 1px solid #ffff;\n}\n.flogo {\n    width: 300px;\n    margin-right: 50px;\n}\n.contact {\n    display: flex;\n    align-items: center;\n    margin-right: 50px;\n}\n\n.footerup .contact .icon {\n    display: flex; \n    justify-content: center;\n    align-items: center;\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    background-color: #FFB342;\n    margin-right: 1rem;\n}\n\n.contact .text {\n    color: #fff;\n    display: flex; \n    flex-direction: column; \n    justify-content: center;\n    text-align: left;\n}\n.footerdown {\n    display: flex;\n    padding: 20px 0 20px 0;\n}\n.footerdown .text {\n    color: #ffff;\n    margin-left: 30px;\n}\n.copyright {\n    color: #ffff;\n    text-align: center;\n    padding: 0 150px;\n}\n.footerdown .icon {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    background-color: #152046;\n    text-align: center;\n    padding: 0.7rem;\n    margin-right: 1rem;\n}\n.sicon {\n    color: #ffff;\n}\n\n@media (max-width:1220px) {\n    .footerup {\n        flex-wrap: wrap;\n        max-width: 100%;\n        width: 100%;\n    }\n    .flogo {\n        margin-bottom: 1rem;\n        max-width: 100%;\n    }\n    .contact {\n        max-width: 100%;\n        width: 100%;\n        margin-bottom: 1rem;\n    }\n    .copyright {\n        display: none;\n    }\n\n    .footerdown .icons{\n        margin-top: 1rem;\n        display: flex;\n        width: 100%;\n    }\n}\n@media (max-width:1220px) {\n    .footer {\n        padding-bottom: 80px; /* 預留空間，大於那三顆按鈕的高度 */\n    }\n    \n    .footerdown {\n        flex-direction: column;  /* 手機板改成上下排 */\n        align-items: flex-start; /* 左對齊，如果想要置中可以改成 center */\n    }\n\n    .footerdown .text {\n        margin-left: 0;   /* 清掉原本左邊距，避免擠到 */\n        margin-bottom: 1rem; /* 跟 icons 保持一點間距 */\n    }\n\n    .footerdown .icons {\n        margin-top: 0;  /* 因為已經有 text 的 margin-bottom */\n        width: 100%;\n        justify-content: flex-start; /* 你也可以改成 center 置中 */\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
